import { useAuth } from '@/contexts/AuthContext'
import { api } from '@/lib/api'
import type { EmailTemplate } from '@/types'
import { useEffect, useState } from 'react'

export function useEmailTemplate() {
    const [template, setTemplate] = useState<EmailTemplate | null>(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)
    const { user } = useAuth()

    useEffect(() => {
        const fetchTemplate = async () => {
            if (!user?.email) {
                setError('No user email available')
                setLoading(false)
                return
            }

            try {
                setLoading(true)
                const data = await api.getEmailTemplate(user.email)
                setTemplate(data)
            } catch (err) {
                setError(err instanceof Error ? err.message : 'Failed to fetch email template')
            } finally {
                setLoading(false)
            }
        }

        fetchTemplate()
    }, [user])

    const updateTemplate = async (newTemplate: EmailTemplate) => {
        try {
            await api.updateEmailTemplate(newTemplate)
            setTemplate(newTemplate)
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Failed to update email template')
            throw err
        }
    }

    return { template, loading, error, updateTemplate }
} 